export class JobCategoryType {
    readonly name: string;
    readonly id: number;

    private constructor(id: number, name: string) {
        this.id = id;
        this.name = name;
    }

    public isIn = (arr: { jobCategoryTypeId: number }[]): boolean => {
        arr = arr != null ? arr : [];
        return arr.findIndex(t => t.jobCategoryTypeId === this.id) >= 0;
    };

    public static asArray = () => [JobCategoryType.NoneOfThesePositions];

    public static fromId = (id: number) =>
        JobCategoryType.asArray().find(t => t.id === id);

    public static NoneOfThesePositions = new JobCategoryType(
        1638,
        "none of these positions"
    );
}
